import { Button, Flex, Input, Radio } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TOKEN = 'b320ac9ed602976a893709000b23e200';
const BASE_URL = 'https://api.tianditu.gov.cn/api?v=4.0&tk=' + TOKEN;
const VEC_URL = 'http://t0.tianditu.gov.cn/vec_w/wmts?tk=' + TOKEN;
const CVA_URL = 'http://t0.tianditu.gov.cn/cva_w/wmts?tk=' + TOKEN;

const MapComponent = ({ centerData, onCenterChange, onLocationSelect }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const mapContainer = useRef(null);
    const mapRef = useRef(null); // 保存地图实例
    const coordinatePickupRef = useRef(null); // 保存坐标拾取器实例
    const [search, setSearch] = useState('');
    const [center, setCenter] = useState({ lon: 116.397428, lat: 39.90923 }); // 地图中心点状态
    const [clickPosition, setClickPosition] = useState({ lon: 116.397428, lat: 39.90923 }); // 点击位置状态
    const [mode, setMode] = useState('center'); // 模式：'center' 中心点模式，'click' 点击模式

    // const handleCenterChange = () => {
    //     // 根据当前模式决定使用哪个位置
    //     const selectedLocation = mode === 'center' ? center : clickPosition;
    //     navigate('/ProjectUpload', { state: { center: selectedLocation } });
    // }

    // 模式切换处理函数
    const handleModeChange = (e) => {
        setMode(e.target.value);
        // 根据新模式传递对应的位置给父组件
        const selectedLocation = e.target.value === 'center' ? center : clickPosition;
        if (onLocationSelect) {
            onLocationSelect(selectedLocation);
        }
    };

    useEffect(() => {
        // 动态加载天地图主库
        const script = document.createElement('script');
        script.src = BASE_URL;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            if (window.T && mapContainer.current) {
                // 创建地图实例
                const map = new window.T.Map(mapContainer.current);
                map.centerAndZoom(new window.T.LngLat(116.397428, 39.90923), 10);
                mapRef.current = map;

                // 创建坐标拾取器
                const cp = new window.T.CoordinatePickup(map, { callback: getLngLat });
                cp.addEvent();
                coordinatePickupRef.current = cp;

                // 监听地图移动事件，实时获取中心点经纬度
                map.addEventListener('moveend', () => {
                    const c = map.getCenter();
                    const newCenter = { lon: c.lng, lat: c.lat };
                    setCenter(newCenter);
                });

                function getLngLat(lnglat) {
                    const newClickPosition = { lon: lnglat.lng, lat: lnglat.lat };
                    setClickPosition(newClickPosition);
                }
            }
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []); // 移除依赖项，只在组件挂载时执行一次

    // 监听模式变化，及时传递对应的位置数据
    useEffect(() => {
        const selectedLocation = mode === 'center' ? center : clickPosition;
        if (onLocationSelect) {
            onLocationSelect(selectedLocation);
        }
    }, [mode]); // 只监听模式变化

    // 监听中心点变化，在中心点模式下向父组件传递数据
    useEffect(() => {
        if (mode === 'center') {
            if (onCenterChange) {
                onCenterChange(center);
            }
            if (onLocationSelect) {
                onLocationSelect(center);
            }
        }
    }, [center, mode, onCenterChange, onLocationSelect]);

    // 监听点击位置变化，在点击模式下向父组件传递数据
    useEffect(() => {
        if (mode === 'click' && onLocationSelect) {
            onLocationSelect(clickPosition);
        }
    }, [clickPosition, mode, onLocationSelect]);

    // 搜索并定位
    const handleSearch = async () => {
        if (!search) return;
        // 天地图地理编码API
        const url = `https://api.tianditu.gov.cn/geocoder?ds={"keyWord":"${encodeURIComponent(search)}"}&tk=${TOKEN}`;
        try {
            const res = await fetch(url);
            const data = await res.json();
            if (data && data.location) {
                const { lon, lat } = data.location;
                const newLocation = { lon, lat };
                if (mapRef.current) {
                    mapRef.current.centerAndZoom(new window.T.LngLat(lon, lat), 15);
                    setCenter(newLocation);
                    console.log("搜索结果位置：", newLocation);
                    
                    // 根据当前模式决定是否向父组件传递搜索结果位置
                    if (mode === 'center' && onLocationSelect) {
                        onLocationSelect(newLocation);
                    }
                }
            } else {
                alert('未找到该地址');
            }
        } catch (e) {
            alert('搜索失败');
        }
    };

    return (
        <Flex vertical direction="column" align="center" justify="center" style={{ padding: 20 }}>
            {/* 模式选择 */}
            <div style={{ marginBottom: 16 }}>
                <Radio.Group value={mode} onChange={handleModeChange}>
                    <Radio value="center">地图中心点模式</Radio>
                    <Radio value="click">鼠标点击模式</Radio>
                </Radio.Group>
            </div>

            <div style={{ marginBottom: 8 }}>
                <Input
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="请输入地址名称"
                    style={{ width: 200, marginRight: 8 }}
                />
                <Button type='primary' onClick={handleSearch}>搜索</Button>
            </div>
            <div ref={mapContainer} style={{ width: '500px', height: '400px' }} />

            {/* 显示当前选中模式的经纬度 */}
            <div
                id='lnglatStr'
                style={{
                    zIndex: 1000,
                    background: 'rgba(255,255,255,0.9)',
                    padding: 8,
                    borderRadius: 4,
                    left: 20,
                    top: 80,
                    fontSize: 14,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    marginTop: 8
                }}
            >
                <div style={{ marginBottom: 4, fontWeight: 'bold' }}>
                    当前模式: {mode === 'center' ? '地图中心点' : '鼠标点击位置'}
                </div>
                {mode === 'center' ? (
                    <div>
                        中心点 - 经度: {
                            center.lon && typeof center.lon === 'number'
                                ? center.lon.toFixed(6)
                                : '0.000000'
                        }，纬度: {
                            center.lat && typeof center.lat === 'number'
                                ? center.lat.toFixed(6)
                                : '0.000000'
                        }
                    </div>
                ) : (
                    <div>
                        点击位置 - 经度: {
                            clickPosition.lon && typeof clickPosition.lon === 'number'
                                ? clickPosition.lon.toFixed(6)
                                : '0.000000'
                        }，纬度: {
                            clickPosition.lat && typeof clickPosition.lat === 'number'
                                ? clickPosition.lat.toFixed(6)
                                : '0.000000'
                        }
                    </div>
                )}
                {/* <Button type='primary' onClick={handleCenterChange}>{t('ButtonList.Located')}</Button> */}
            </div>
        </Flex>
    );
};

export default MapComponent;